import { brandConfig } from '@/config/brand';
import { marketplaceNav } from '@/config/marketplaceNav';
import type { NavTourStepId } from './navTourSteps';

/** Web href to show for a nav-tour step (Next/Back chrome). */
export function hrefForNavTourStep(stepId: NavTourStepId): string | null {
  switch (stepId) {
    case 'home':
      return '/';
    case 'forums':
      return brandConfig.forum.path;
    case 'groups':
      return brandConfig.groups.path;
    case 'calendar':
      return brandConfig.calendar.path;
    case 'blog':
      return brandConfig.blog.path;
    case 'feedback':
      return brandConfig.feedback.path;
    case 'marketplace':
      return marketplaceNav.rootHref;
    case 'marketplace-enable':
      return '/settings/account/';
    case 'theme':
      return null;
    default:
      return null;
  }
}
